<template>
  <div class="views">
    <div class="topTitle flex">
      <span class="preview"></span>
      <el-input v-model="searchResult" placeholder="请输入商家或小程序名称" style="width:200px"></el-input>
      <div class="searchs">
        <el-button type="primary" @click="search">查询</el-button>
      </div>
    </div>
    <!-- <el-radio :label="scope.row.id" v-model="masterId">&nbsp;</el-radio> -->
    <div class="from">
      <el-table
          stripe
          border
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          id="table"
          size="small"
      >
        <el-table-column prop="nickName" label="小程序名称" align="center">
          <template slot-scope="scope">
            <div class="nikename flex">
              <span class="front">{{ scope.row.nickName }}</span>
              <span class="after">{{ scope.row.principalName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="admin_id" label="时间" align="center">
          <template>
            <div class="nikename flex">
              <span class="front">昨日</span>
              <span class="after">前一天</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="theDayBeforeVisitUv"
          label="访问人数"
          align="center"
        >
          <template slot-scope="scope">
            <div class="nikename flex">
              <span class="front">{{ scope.row.visitUv }}</span>
              <span class="after">{{ scope.row.theDayBeforeVisitUv }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sessionCnt" label="启动次数" align="center">
          <template slot-scope="scope">
            <div class="nikename flex">
              <span class="front">{{ scope.row.sessionCnt }}</span>
              <span class="after">{{ scope.row.theDayBeforeSessionCnt }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" align="center">
          <template  slot-scope="scope">
            <el-button size="mini" @click="queryDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="uploadedMpTempListTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchResult: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      uploadedMpTempListTotal: 0,
    };
  },
  created() {
    this.get_init();
  },
  methods: {
    async get_init() {
      const { result } = await this.$store.dispatch("queryAllWechat", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchResult,
      });
      this.tableData = result.records;
      this.uploadedMpTempListTotal = result.total;
      console.log(this.tableData);
    },
    paging(page) {
      this.currentPage = page;
      this.get_init();
    },
    search() {
      this.get_init();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.get_init();
    },
    queryDetail(row) {
      console.log(row);
      this.$router.push({
        name: "TrafficView",
        query: {
          busType: row.busType,
          storeCode: row.storeCode
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.views{
  flex-direction: column;
   .topTitle {
    background: #fff;
    margin-bottom: 10px;
    padding: 20px;
    align-items: center;
    justify-content: flex-end;
    // align-items: center;
    // border-bottom: 1px solid #e5e9f2;
    .preview {
      color: #222222;
      font-weight: 500;
      font-size: 26;
    }
    .searchs{
      margin-left: 20px;
    }
  }
  .from{
    background: #FFFFFF;
    padding: 20px;
  }
}


.nikename {
  flex-direction: column;
  .front {
    font-size: 14px;
    color: #222222;
  }
  .after {
    font-size: 14px;
    color: #aaaaaa;
  }
}
.contain {
  padding: 0 20px;
  justify-content: space-between;
  margin-bottom: 30px;
  .title {
    font-size: 22px;
    color: #222222;
    font-weight: 500;
  }
  .searchs {
  }
}
</style>
